import { createRxDatabase, RxDatabase } from 'rxdb';
import { catchError, defer, first, mergeMap, Observable, retry, timer } from 'rxjs';
import { getRxStorageDexie } from 'rxdb/plugins/storage-dexie';
import { ConfigCollection, configSchema } from './config';
import { DefaultErrors } from '../../model/error';
import Log from '../../util/log';

export type PlatformCollections = {
  config: ConfigCollection;
};

export type PlatformDatabase = RxDatabase<PlatformCollections>;

export function getDatabase(id: string): Observable<PlatformDatabase> {
  return defer(() =>
    createRxDatabase<PlatformCollections>({
      name: id,
      storage: getRxStorageDexie(),
      ignoreDuplicate: true,
    }),
  ).pipe(
    mergeMap((db) => {
      return db
        .addCollections({
          config: {
            schema: configSchema,
          },
        })
        .then(() => db);
    }),
    retry({
      count: 5,
      delay: () => {
        return timer(3000);
      },
    }),
    catchError((error) => {
      Log.error(error);
      throw DefaultErrors.DATABASE_ACCESS_DENIED;
    }),
    first(),
  );
}
